
export default function grantPurposeDropdown(){
    return [{
      grantPurposeId:1,
      purpose:"Unrestricted Gift",
      certificationContent: "",
      certificationRequired: true,
      commentsAllowed: false ,
      commentsLabelName: "Additional information for the charity",
      commentsRequired: false,
      deprecatedGpId: 0,
      description: "Unrestricted Gift",
      descriptiveContent: "Please provide a brief description of the charitable purpose of the grant.",
      displayOrder: 1,
    },{
      grantPurposeId:2,
      purpose:"Other" ,
      certificationContent: "",
      certificationRequired: true,
      commentsAllowed: true,
      commentsLabelName: "Additional information for the charity",
      commentsRequired: true,
      deprecatedGpId: 0,
      description: "Other",
      descriptiveContent: "Please provide a brief description of the charitable purpose of the grant.",
      displayOrder: 2,
    }]
  } 